import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from '@/components/merchant/Sidebar';
import EarnSuccessModal from '@/components/guest/EarnSuccessModal';
import LanguageToggle from '@/components/common/LanguageToggle';
import useStore, { BRAND_COLORS } from '@/store/useStore';

function hexToRgbString(hex) {
  const safe = (hex || '').replace('#', '');
  if (safe.length !== 6) return '14, 122, 98';
  const n = Number.parseInt(safe, 16);
  return `${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}`;
}

function resolveMerchantColor(value) {
  if (value && BRAND_COLORS[value]) return BRAND_COLORS[value];
  if (typeof value === 'string' && /^#[0-9a-fA-F]{6}$/.test(value)) {
    return { hex: value, start: value, end: value };
  }
  return BRAND_COLORS.brand;
}

export default function MerchantLayout() {
  const { merchantBrandColor } = useStore();
  const location = useLocation();

  // Apply merchant brand color to CSS variables
  useEffect(() => {
    const color = resolveMerchantColor(merchantBrandColor);
    if (color) {
      document.documentElement.style.setProperty('--brand-start', color.start || color.hex);
      document.documentElement.style.setProperty('--brand-end', color.end || color.hex);
      document.documentElement.style.setProperty('--brand-solid', color.hex);
      document.documentElement.style.setProperty('--brand-rgb', hexToRgbString(color.hex));
    }
  }, [merchantBrandColor]);

  return (
    <div className="flex min-h-screen bg-[#f7f7f4]" data-testid="merchant-layout">
      <Sidebar />
      <main className="flex-1 overflow-auto">
        <div className="h-14 border-b border-stone-200 bg-white/90 backdrop-blur px-6 lg:px-8 flex items-center justify-end">
          <div className="flex items-center gap-3">
            <LanguageToggle />
            <img src="/assets/flyback.png" alt="FlyBack" className="h-7 w-auto object-contain" />
          </div>
        </div>
        <div className="p-6 lg:p-8" key={location.pathname}><Outlet /></div>
      </main>
      <EarnSuccessModal />
    </div>
  );
}
